import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import googleAnalytics from "./googleAnalytics";

createApp(App).use(store).use(router).use(googleAnalytics).mount("#app");
